import React from "react";
import "./homepage.css";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import HomepageNavbar from "../../components/navbar/Navbar";

const NewHomepage = () => {
  const openInNewTab = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="homepage-container">
        <HomepageNavbar />
      
      <section className="banner-section relative">
        {/* Banner Image */}
        <img
          src={require("../../assets/cohesive-minds/Master banner - test prep.jpg")}
          alt="Banner"
          className="banner-image w-screen md:h-[85vh] object-fill"
        />

        {/* Responsive Positioned Button */}
        <button
          onClick={() => openInNewTab("https://youtu.be/WoFun7AMoiE")}
          className="
            absolute bottom-[1.25rem] right-[0.5rem] 
            md:bottom-[8rem] md:right-[7rem] 
            lg:bottom-[7rem] lg:right-[8rem] 
            xl:bottom-[10rem] xl:right-[13rem]
            bg-[#FF820F] text-white font-bold py-4 px-8 
            cursor-pointer rounded-lg hover:bg-[#e6740d] transition z-10 border-transparent"
        >
          GET STARTED TODAY
        </button>
      </section>


      <h1 className="md:text-center text-center text-[#FF820F] text-[23px] md:text-13xl font-bold">
        TAILORED FOR SUCCESS
      </h1>

      {/* Clickable Images Section */}
      <section className="clickable-images-section">
        <div className="image-row flex flex-col md:flex-row items-center justify-center gap-16">
          {/* CUET */}
          <div className="flex flex-col">
            <img
              src={require("../../assets/cohesive-minds/CUET Img 1.jpeg")}
              alt="CUET 1"
              className="clickable-image w-[24rem] h-[24rem] object-cover rounded-lg shadow-lg"
              onClick={() => openInNewTab("https://cohesiveminds.testknock.com/cuet")}
            />
            <button
              onClick={() => openInNewTab("https://cohesiveminds.testknock.com/cuet")}
              className="mt-4 bg-[#FF820F] text-white font-bold py-2 px-4 cursor-pointer rounded-lg hover:bg-[#e6740d] transition border-transparent"
            >
              Enroll Now
            </button>
          </div>

          {/* General Aptitude Edge */}
          <div className="flex flex-col">
            <img
              src={require("../../assets/cohesive-minds/GAE Img 2.jpeg")}
              alt="General Aptitude Edge"
              className="clickable-image w-[24rem] h-[24rem] object-cover rounded-lg shadow-lg"
              onClick={() => openInNewTab("https://www.cohesiveminds.com/category/high-schoolers/")}
            />
            <button
              onClick={() => openInNewTab("https://www.cohesiveminds.com/category/high-schoolers/")}
              className="mt-4 bg-[#FF820F] text-white font-bold py-2 px-4 cursor-pointer rounded-lg hover:bg-[#e6740d] transition border-transparent"
            >
              Enroll Now
            </button>
          </div>

          {/* Fashion, Art & Design */}
          <div className="flex flex-col">
            <img
              src={require("../../assets/cohesive-minds/FAD Img 3.jpeg")}
              alt="Fashion, Art & Design"
              className="clickable-image w-[24rem] h-[24rem] object-cover rounded-lg shadow-lg"
              onClick={() => openInNewTab("https://www.cohesiveminds.com/category/high-schoolers/")}
            />
            <button
              onClick={() => openInNewTab("https://www.cohesiveminds.com/category/high-schoolers/")}
              className="mt-4 bg-[#FF820F] text-white font-bold py-2 px-4 cursor-pointer rounded-lg hover:bg-[#e6740d] transition border-transparent"
            >
              Enroll Now
            </button>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="info-section">
        <div className="info-box">
          <h3>CUET Test Prep</h3>
          <ul>
            <li>✅ Comprehensive coverage of subject-specific topics.</li>
            <li>✅ General test preparation with focus on quantitative aptitude, logical reasoning, and verbal ability.</li>
            <li>✅ Recorded video lessons, practice exercises & mock tests to simulate real exam conditions.</li>
            <li>✅ Personalized progress tracking for targeted improvement.</li>
          </ul>
        </div>
        <div className="info-box">
          <h3>General Aptitude Edge</h3>
          <ul>
            <li>✅ Strengthen your core skills in logical reasoning, verbal ability, and problem-solving.</li>
            <li>✅ Build the foundation for success in all competitive exams.</li>
            <li>✅ Hands-on learning modules with curated toolkits.</li>
            <li>✅ Real-world application for professional readiness beyond exams.</li>
          </ul>
        </div>
        <div className="info-box">
          <h3>Fashion, Art & Design Test Prep</h3>
          <ul>
            <li>✅ Tailored preparation for entrance exams in top creative institutes.</li>
            <li>✅ Design fundamentals, portfolio building, and creativity-enhancing exercises.</li>
            <li>✅ Personalized coaching to help you present your best work.</li>
            <li>✅ Mock tests and evaluation support to boost your confidence.</li>
          </ul>
        </div>
      </section>

      <section className="relative px-[40px] mb-[40px] flex flex-col md:flex-row items-center">
      {/* Left: Image */}
      <div className="w-full md:w-1/2">
        <img
          src={require("../../assets/cohesive-minds/college quest footer.png")} // Update with your actual image path
          alt="Graduation Celebration"
          className="w-full h-auto rounded-lg shadow-lg"
        />
      </div>

      {/* Right: Content */}
      <div className="w-full md:w-1/2 md:pl-10 text-center md:text-left">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">
          UNLOCK YOUR FUTURE WITH COLLEGE QUEST
        </h2>
        <p className="text-gray-700 mb-3">
          Navigating the path from school to college can feel overwhelming—but it doesn’t have to be.
        </p>
        <p className="text-gray-700 mb-3">
          <strong>College Quest by Cohesive Minds</strong> is your comprehensive, one-stop solution to charting a successful higher education journey.
        </p>
        <p className="text-gray-700 mb-5">
          Our program is designed to guide you through every crucial step—from exploring career pathways to excelling in entrance exams—with personalized support and actionable insights.
        </p>

        <button
          onClick={() => openInNewTab("https://www.cohesiveminds.com/p/college-quest/")}
          className="
            bg-[#FF820F] text-white font-bold py-2 px-4 
            cursor-pointer rounded-lg hover:bg-[#e6740d] transition z-10 border-transparent"
          >
          Learn more
        </button>
      </div>
    </section>

      <Footer />
    </div>
  );
};

export default NewHomepage;
